/**
 * Persistencia del dismiss del SoftLimitCreceCard.
 * - `volume_over` snoozea 1 día (lead caliente: reaparece a diario si sigue excedido).
 * - `volume_near` / `structural` / `legacy_volume` quedan dismissed por todo el período.
 * - `legacy_home` usa período fijo `LEGACY_HOME_DISMISS_PERIOD` (banner Inicio plan original).
 * La key incluye el kind: quien dismissó en "near" y después pasó a "over" ve el card de nuevo.
 */
import AsyncStorage from '@react-native-async-storage/async-storage';

export type SoftLimitKind =
  | 'volume_near'
  | 'volume_over'
  | 'structural'
  | 'legacy_volume'
  | 'legacy_home';

/** Período fijo para dismiss del banner legacy en Inicio (no rota por mes). */
export const LEGACY_HOME_DISMISS_PERIOD = 'home';

const OVER_SNOOZE_MS = 24 * 60 * 60 * 1000;

const dismissKey = (orgId: string, periodMonth: string, kind: SoftLimitKind) =>
  `billing.softLimit.dismissed.v1.${orgId}.${periodMonth}.${kind}`;

export async function isSoftLimitDismissed(
  orgId: string,
  periodMonth: string,
  kind: SoftLimitKind,
): Promise<boolean> {
  try {
    const raw = await AsyncStorage.getItem(dismissKey(orgId, periodMonth, kind));
    if (raw == null) return false;
    if (kind !== 'volume_over') return true;
    const dismissedAt = Number(raw);
    if (!Number.isFinite(dismissedAt)) return true;
    return Date.now() - dismissedAt < OVER_SNOOZE_MS;
  } catch {
    return false;
  }
}

export async function dismissSoftLimit(
  orgId: string,
  periodMonth: string,
  kind: SoftLimitKind,
): Promise<void> {
  try {
    await AsyncStorage.setItem(dismissKey(orgId, periodMonth, kind), String(Date.now()));
  } catch {
    // storage no disponible: el dismiss queda solo en estado de sesión
  }
}
